module.exports = __webpack_public_path__ + "static/images/components/ChallengeContent/components/Label/images/wing-right.bbe8813e.png";


//////////////////
// WEBPACK FOOTER
// ./components/ChallengeContent/components/Label/images/wing-right.png
// module id = 2592
// module chunks = 11